export default __webpack_public_path__ + "static/media/LogoSKB.fe60fbd0.png";